define("powergen/controllers/systems",
  [],
  function() {
    "use strict";
    var SystemsController;

    SystemsController = Ember.ObjectController.extend({
      actions: {
        select: function(system) {
          if (!system.get('isComplete')) {
            return this.transitionToRoute('system', system);
          } else {
            throw new Error('System already complete');
          }
        },
        showOverlay: function(system) {
          return this.setProperties({
            'selectedSystem': system,
            'showOverlay': true
          });
        },
        finished: function() {
          var _this = this;
          if (!this.get('manager')["static"]) {
            return $.ajax({
              method: 'POST',
              url: '/api/score',
              data: {
                firstName: this.get('manager.user.firstName').capitalize(),
                lastName: this.get('manager.user.lastName').capitalize(),
                email: this.get('manager.user.email'),
                score: this.get('averageScore')
              },
              success: function(response) {
                _this.setProperties({
                  'manager.lastScoreId': response.score.id
                });
                _this.get('model').reset();
                return _this.transitionToRoute('index');
              }
            });
          } else {
            this.get('model').reset();
            return this.transitionToRoute('index');
          }
        }
      },
      showOverlay: false,
      averageScore: (function() {
        var scores, total;
        scores = this.get('systems').map(function(system) {
          return system.get('points');
        });
        scores = scores.compact();
        if (scores.length === 0) {
          return 0;
        }
        total = scores.reduce(function(previousValue, item, index, enumerable) {
          if (previousValue === void 0) {
            previousValue = 0;
          }
          return previousValue + item;
        });
        return Math.round(total / scores.length);
      }).property('systems.@each.points'),
      anySystemsComplete: (function() {
        return this.get('systems').anyBy('isComplete', true);
      }).property('systems.@each.isComplete'),
      allSystemsComplete: (function() {
        return this.get('systems').everyBy('isComplete', true);
      }).property('systems.@each.isComplete')
    });


    return SystemsController;
  });